import router from '@/router'
import axios, { AxiosInstance } from 'axios'
import { VueConstructor } from 'vue'
import { Vue } from 'vue/types/vue'

type ErrorHandlers = {
  [key: number]: () => void | undefined;
}

const HandlersDefs: ErrorHandlers = {
  404: () => {
    router.push('/not-found-404')
  }
}

export const AxiosPlugin = {
  install(Vue: VueConstructor) {
    const $axios = axios.create({
      baseURL: process.env.VUE_APP_BASE_URL
    })
    $axios.interceptors.response.use((value) => value, (error) => {
      const handler = HandlersDefs[error.response.status]
      if (handler) {
        handler()
      }

      return error
    })
    Vue.prototype.$axios = $axios
  }
}

declare module 'vue/types/vue' {
  interface Vue {
    $axios: AxiosInstance;
  }
}
